const themeStyles = colors => {
  const styles = {
    noDataContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 16,
      color: colors.secondaryGray
    }
  }
  return styles
}

export default themeStyles
